module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../../../../node_modules/happypack/loader.js?id=jsx!./SwitchView.js"));
	}, "SwitchView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=SwitchView!./src/pages/Shop/Member/TradeManage/OrderSwitch/Switch/SwitchView.js
// module id = 1044
// module chunks = 431